export default "__VITE_ASSET__BIVnMc5i__"